// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"18678726","703":"b3b7df74"}[chunkId] + ".chunk.js";
};